import Provider from "./Provider-Api";
import CheckApi from "./check-api";

// STAFF MANAGEMENT 

export const settingGetDepartment = async (data, token) => {
    CheckApi('getDepartment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getDepartment",
        data,
        token
    });
    CheckApi('dataRes-getDepartment', dataRes)
    return dataRes;
};

export const settingAddDepartment = async (data, token) => {
    CheckApi('addDepartment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addDepartment",
        data,
        token
    });
    CheckApi('dataRes-addDepartment', dataRes)
    return dataRes;
};

export const settingDeleteDepartment = async (item, token) => {
    CheckApi('deleteDepartment', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteDepartment",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteDepartment', dataRes)
    return dataRes;
};

export const settingUpdateDepartment = async (data, token) => {
    CheckApi('updateDepartment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateDepartment",
        data,
        token
    });
    CheckApi('dataRes-updateDepartment', dataRes)
    return dataRes;
};

export const settingGetPosition = async (data, token) => {
    CheckApi('getPosition', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPosition",
        data,
        token
    });
    CheckApi('dataRes-getPosition', dataRes)
    return dataRes;
};

export const settingAddPosition = async (data, token) => {
    CheckApi('addPosition', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPosition",
        data,
        token
    });
    CheckApi('dataRes-addPosition', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeletePosition = async (data, token) => {
    CheckApi('getCheckDataDeletePosition', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeletePosition",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeletePosition', dataRes)
    return dataRes;
};

export const settingDeletePosition = async (item, token) => {
    CheckApi('deletePosition', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePosition",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePosition', dataRes)
    return dataRes;
};

export const settingUpdatePosition = async (data, token) => {
    CheckApi('updatePosition', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePosition",
        data,
        token
    });
    CheckApi('dataRes-updatePosition', dataRes)
    return dataRes;
};

export const settingGetStaff = async (data, token) => {
    CheckApi('getStaff', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getStaff",
        data,
        token
    });
    CheckApi('dataRes-getStaff', dataRes)
    return dataRes;
};

export const settingGetStaffWithOutOwner = async (data, token) => {
    CheckApi('getStaffWithOutOwner', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getStaffWithOutOwner",
        data,
        token
    });
    CheckApi('dataRes-getStaffWithOutOwner', dataRes)
    return dataRes;
};

export const settingGetCheckUserByStaff = async (data, token) => {
    CheckApi('getCheckUserByStaff', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckUserByStaff",
        data,
        token
    });
    CheckApi('dataRes-getCheckUserByStaff', dataRes)
    return dataRes;
};

export const settingGetCheckEmailStaff = async (data, token) => {
    CheckApi('getCheckEmailStaff', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckEmailStaff",
        data,
        token
    });
    CheckApi('dataRes-getCheckEmailStaff', dataRes)
    return dataRes;
};


export const settingCreateStaff = async (data, token) => {
    CheckApi('createStaff', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/createStaff",
        data,
        token
    });
    CheckApi('dataRes-createStaff', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteStaff = async (data, token) => {
    CheckApi('getCheckDataDeleteStaff', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteStaff",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteStaff', dataRes)
    return dataRes;
};


export const settingDeleteStaff = async (item, token) => {
    CheckApi('deleteStaff', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteStaff",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteStaff', dataRes)
    return dataRes;
};

export const settingUpdateStaff = async (data, token) => {
    CheckApi('updateStaff', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateStaff",
        data,
        token
    });
    CheckApi('dataRes-updateStaff', dataRes)
    return dataRes;
};

export const settingGetAllTherapistTreatmentMapping = async (data, token) => {
    CheckApi('getAllTherapistTreatmentMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllTherapistTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-getAllTherapistTreatmentMapping', dataRes)
    return dataRes;
};

export const settingGetTherapistTreatmentMapping = async (data, token) => {
    CheckApi('getTherapistTreatmentMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTherapistTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-getTherapistTreatmentMapping', dataRes)
    return dataRes;
};

export const settingGetTherapistTreatmentMappingByTreatmentInBooking = async (data, token) => {
    CheckApi('getTherapistTreatmentMappingByTreatmentInBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTherapistTreatmentMappingByTreatmentInBooking",
        data,
        token
    });
    CheckApi('dataRes-getTherapistTreatmentMappingByTreatmentInBooking', dataRes)
    return dataRes;
};

export const settingAddTherapistTreatmentMapping = async (data, token) => {
    CheckApi('addTherapistTreatmentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addTherapistTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-addTherapistTreatmentMapping', dataRes)
    return dataRes;
};

export const settingDeleteTherapistTreatmentMapping = async (item, token) => {
    CheckApi('deleteTherapistTreatmentMapping', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteTherapistTreatmentMapping",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteTherapistTreatmentMapping', dataRes)
    return dataRes;
};

export const settingUpdateTherapistTreatmentMapping = async (data, token) => {
    CheckApi('updateTherapistTreatmentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateTherapistTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-updateTherapistTreatmentMapping', dataRes)
    return dataRes;
};


// END STAFF MANAGEMENT

// User Management

export const settingGetPermission = async (data, token) => {
    CheckApi('getPermission', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPermission",
        data,
        token
    });
    CheckApi('dataRes-getPermission', dataRes)
    return dataRes;
};

export const settingAddPermission = async (data, token) => {
    CheckApi('addPermission', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPermission",
        data,
        token
    });
    CheckApi('dataRes-addPermission', dataRes)
    return dataRes;
};

export const settingDeletePermission = async (item, token) => {
    CheckApi('deletePermission', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePermission",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePermission', dataRes)
    return dataRes;
};

export const settingUpdatePermission = async (data, token) => {
    CheckApi('updatePermission', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePermission",
        data,
        token
    });
    CheckApi('dataRes-updatePermission', dataRes)
    return dataRes;
};

export const settingGetUser = async (data, token) => {
    CheckApi('getUser', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getUser",
        data,
        token
    });
    CheckApi('dataRes-getUser', dataRes)
    return dataRes;
};

export const settingAddUser = async (data, token) => {
    CheckApi('addUser', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addUser",
        data,
        token
    });
    CheckApi('dataRes-addUser', dataRes)
    return dataRes;
};

export const settingDeleteUser = async (item, token) => {
    CheckApi('deleteUser', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteUser",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteUser', dataRes)
    return dataRes;
};

export const settingUpdateUser = async (data, token) => {
    CheckApi('updateUser', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateUser",
        data,
        token
    });
    CheckApi('dataRes-updateUser', dataRes)
    return dataRes;
};

export const settingCreateUserPassword = async (data, token) => {
    CheckApi('createUserPassword', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/createUserPassword",
        data,
        token
    });
    CheckApi('dataRes-createUserPassword', dataRes)
    return dataRes;
};

export const settingResetPassword = async (data, token) => {
    CheckApi('resetPassword', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/resetPassword",
        data,
        token
    });
    CheckApi('dataRes-resetPassword', dataRes)
    return dataRes;
};

export const settingGetSpaAgentMapping = async (data, token) => {
    CheckApi('getSpaAgentMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getSpaAgentMapping",
        data,
        token
    });
    CheckApi('dataRes-getSpaAgentMapping', dataRes)
    return dataRes;
};

export const settingAddSpaAgentMapping = async (data, token) => {
    CheckApi('addSpaAgentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addSpaAgentMapping",
        data,
        token
    });
    CheckApi('dataRes-addSpaAgentMapping', dataRes)
    return dataRes;
};

export const settingDeleteSpaAgentMapping = async (item, token) => {
    CheckApi('deleteSpaAgentMapping', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteSpaAgentMapping",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteSpaAgentMapping', dataRes)
    return dataRes;
};

export const settingUpdateSpaAgentMapping = async (data, token) => {
    CheckApi('updateSpaAgentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateSpaAgentMapping",
        data,
        token
    });
    CheckApi('dataRes-updateSpaAgentMapping', dataRes)
    return dataRes;
};


// END User Management

// Company Profile

export const settingGetSpa = async (data, token) => {
    CheckApi('getSpa', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getSpa",
        data,
        token
    });
    CheckApi('dataRes-getSpa', dataRes)
    return dataRes;
};

export const settingGetCompanyInformation = async (data, token) => {
    CheckApi('getCompanyInformation', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCompanyInformation",
        data,
        token
    });
    CheckApi('dataRes-getCompanyInformation', dataRes)
    return dataRes;
};

export const settingUpdateCompanyProfile = async (data, token) => {
    CheckApi('updateCompanyProfile', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateCompanyProfile",
        data,
        token
    });
    CheckApi('dataRes-updateCompanyProfile', dataRes)
    return dataRes;
};

export const settingGetcheckSpaNameandBranchName = async (data, token) => {
    CheckApi('getcheckSpaNameandBranchName', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getcheckSpaNameandBranchName",
        data,
        token
    });
    CheckApi('dataRes-getcheckSpaNameandBranchName', dataRes)
    return dataRes;
};

// END Company Profile

// TREATMENT MANAGEMENT

export const settingGetTreatmentCategory = async (data, token) => {
    CheckApi('getTreatmentCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentCategory",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentCategory', dataRes)
    return dataRes;
};

export const settingAddTreatmentCategory = async (data, token) => {
    CheckApi('addTreatmentCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addTreatmentCategory",
        data,
        token
    });
    CheckApi('dataRes-addTreatmentCategory', dataRes)
    return dataRes;
};

export const settingDeleteTreatmentCategory = async (item, token) => {
    CheckApi('deleteTreatmentCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteTreatmentCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteTreatmentCategory', dataRes)
    return dataRes;
};

export const settingUpdateTreatmentCategory = async (data, token) => {
    CheckApi('updateTreatmentCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateTreatmentCategory",
        data,
        token
    });
    CheckApi('dataRes-updateTreatmentCategory', dataRes)
    return dataRes;
};

export const settingGetTreatmentCenter = async (token) => {
    CheckApi('getTreatmentCenter', token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentCenter",
        token
    });
    CheckApi('dataRes-getTreatmentCenter', dataRes)
    return dataRes;
};

export const settingGetTreatment = async (data, token) => {
    CheckApi('getTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatment",
        data,
        token
    });
    CheckApi('dataRes-getTreatment', dataRes)
    return dataRes;
};

export const settingGetTreatmentOnline = async (data, token) => {
    CheckApi('getTreatmentOnline', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentOnline",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentOnline', dataRes)
    return dataRes;
};

export const settingAddTreatment = async (data, token) => {
    CheckApi('addTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addTreatment",
        data,
        token
    });
    CheckApi('dataRes-addTreatment', dataRes)
    return dataRes;
};

export const settingDeleteTreatment = async (item, token) => {
    CheckApi('deleteTreatment', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteTreatment",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteTreatment', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteTreatment = async (data, token) => {
    CheckApi('getCheckDataDeleteTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteTreatment",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteTreatment', dataRes)
    return dataRes;
};

export const settingUpdateTreatment = async (data, token) => {
    CheckApi('updateTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateTreatment",
        data,
        token
    });
    CheckApi('dataRes-updateTreatment', dataRes)
    return dataRes;
};

export const settingUpdateChangeStatusTreatment = async (data, token) => {
    CheckApi('updateChangeStatusTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateChangeStatusTreatment",
        data,
        token
    });
    CheckApi('dataRes-updateChangeStatusTreatment', dataRes)
    return dataRes;
};

export const settingGetAllTreatmentDuration = async (data, token) => {
    CheckApi('getAllTreatmentDuration', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllTreatmentDuration",
        data,
        token
    });
    CheckApi('dataRes-getAllTreatmentDuration', dataRes)
    return dataRes;
};

export const settingGetAllTreatmentDurationOnline = async (data, token) => {
    CheckApi('getAllTreatmentDurationOnline', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllTreatmentDurationOnline",
        data,
        token
    });
    CheckApi('dataRes-getAllTreatmentDurationOnline', dataRes)
    return dataRes;
};

export const settingGetTreatmentDuration = async (data, token) => {
    CheckApi('getTreatmentDuration', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentDuration",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentDuration', dataRes)
    return dataRes;
};

export const settingAddTreatmentDuration = async (data, token) => {
    CheckApi('addTreatmentDuration', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addTreatmentDuration",
        data,
        token
    });
    CheckApi('dataRes-addTreatmentDuration', dataRes)
    return dataRes;
};

export const settingDeleteTreatmentDuration = async (item, token) => {
    CheckApi('deleteTreatmentDuration', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteTreatmentDuration",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteTreatmentDuration', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteTreatmentDuration = async (data, token) => {
    CheckApi('getCheckDataDeleteTreatmentDuration', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteTreatmentDuration",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteTreatmentDuration', dataRes)
    return dataRes;
};

export const settingUpdateTreatmentDuration = async (data, token) => {
    CheckApi('updateTreatmentDuration', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateTreatmentDuration",
        data,
        token
    });
    CheckApi('dataRes-updateTreatmentDuration', dataRes)
    return dataRes;
};

export const settingGetTreatmentSpaOptional = async (data, token) => {
    CheckApi('getTreatmentSpaOptional', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentSpaOptional",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentSpaOptional', dataRes)
    return dataRes;
};

export const settingAddTreatmentSpaOptional = async (data, token) => {
    CheckApi('addTreatmentSpaOptional', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addTreatmentSpaOptional",
        data,
        token
    });
    CheckApi('dataRes-addTreatmentSpaOptional', dataRes)
    return dataRes;
};

export const settingDeleteTreatmentSpaOptional = async (item, token) => {
    CheckApi('deleteTreatmentSpaOptional', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteTreatmentSpaOptional",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteTreatmentSpaOptional', dataRes)
    return dataRes;
};

// export const settingGetCheckDataDeleteTreatmentSpaOptional = async (data, token) => {
//     CheckApi('getCheckDataDeleteTreatmentSpaOptional', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeleteTreatmentSpaOptional",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeleteTreatmentSpaOptional', dataRes)
//     return dataRes;
// };

export const settingUpdateTreatmentSpaOptional = async (data, token) => {
    CheckApi('updateTreatmentSpaOptional', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateTreatmentSpaOptional",
        data,
        token
    });
    CheckApi('dataRes-updateTreatmentSpaOptional', dataRes)
    return dataRes;
};

export const settingGetTreatmentDurationProduct = async (data, token) => {
    CheckApi('getTreatmentDurationProduct', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentDurationProduct",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentDurationProduct', dataRes)
    return dataRes;
};

// export const settingGetCheckDataDeleteTreatmentDurationProduct = async (data, token) => {
//     CheckApi('getCheckDataDeleteTreatmentDurationProduct', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeleteTreatmentDurationProduct",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeleteTreatmentDurationProduct', dataRes)
//     return dataRes;
// };

export const settingGetTreatmentSpaOptionalProduct = async (data, token) => {
    CheckApi('getTreatmentSpaOptionalProduct', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getTreatmentSpaOptionalProduct",
        data,
        token
    });
    CheckApi('dataRes-getTreatmentSpaOptionalProduct', dataRes)
    return dataRes;
};

// export const settingGetCheckDataDeleteTreatmentSpaOptionalProduct = async (data, token) => {
//     CheckApi('getCheckDataDeleteTreatmentSpaOptionalProduct', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeleteTreatmentSpaOptionalProduct",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeleteTreatmentSpaOptionalProduct', dataRes)
//     return dataRes;
// };


// END TREATMENT MANAGEMENT

// BED  MANAGEMENT 

export const settingGetBedCategory = async (data, token) => {
    CheckApi('getBedCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getBedCategory",
        data,
        token
    });
    CheckApi('dataRes-getBedCategory', dataRes)
    return dataRes;
};

export const settingAddBedCategory = async (data, token) => {
    CheckApi('addBedCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addBedCategory",
        data,
        token
    });
    CheckApi('dataRes-addBedCategory', dataRes)
    return dataRes;
};

export const settingDeleteBedCategory = async (item, token) => {
    CheckApi('deleteBedCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteBedCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBedCategory', dataRes)
    return dataRes;
};

export const settingUpdateBedCategory = async (data, token) => {
    CheckApi('updateBedCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateBedCategory",
        data,
        token
    });
    CheckApi('dataRes-updateBedCategory', dataRes)
    return dataRes;
};

export const settingGetBed = async (data, token) => {
    CheckApi('getBed', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getBed",
        data,
        token
    });
    CheckApi('dataRes-getBed', dataRes)
    return dataRes;
};

export const settingGetRoomBedMappingByTreatmentInBooking = async (data, token) => {
    CheckApi('getRoomBedMappingByTreatmentInBooking', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getRoomBedMappingByTreatmentInBooking",
        data,
        token
    });
    CheckApi('dataRes-getRoomBedMappingByTreatmentInBooking', dataRes)
    return dataRes;
};

export const settingAddBed = async (data, token) => {
    CheckApi('addBed', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addBed",
        data,
        token
    });
    CheckApi('dataRes-addBed', dataRes)
    return dataRes;
};

export const settingDeleteBed = async (item, token) => {
    CheckApi('deleteBed', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteBed",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteBed', dataRes)
    return dataRes;
};

export const settingUpdateBed = async (data, token) => {
    CheckApi('updateBed', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateBed",
        data,
        token
    });
    CheckApi('dataRes-updateBed', dataRes)
    return dataRes;
};

export const settingGetRoom = async (data, token) => {
    CheckApi('getRoom', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getRoom",
        data,
        token
    });
    CheckApi('dataRes-getRoom', dataRes)
    return dataRes;
};

export const settingAddRoom = async (data, token) => {
    CheckApi('addRoom', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addRoom",
        data,
        token
    });
    CheckApi('dataRes-addRoom', dataRes)
    return dataRes;
};

export const settingDeleteRoom = async (item, token) => {
    CheckApi('deleteRoom', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteRoom",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteRoom', dataRes)
    return dataRes;
};

export const settingUpdateRoom = async (data, token) => {
    CheckApi('updateRoom', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateRoom",
        data,
        token
    });
    CheckApi('dataRes-updateRoom', dataRes)
    return dataRes;
};

export const settingUpdateChangeStatusRoom = async (data, token) => {
    CheckApi('updateChangeStatusRoom', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateChangeStatusRoom",
        data,
        token
    });
    CheckApi('dataRes-updateChangeStatusRoom', dataRes)
    return dataRes;
};

export const settingGetAllRoomBedMapping = async (data, token) => {
    CheckApi('getAllRoomBedMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllRoomBedMapping",
        data,
        token
    });
    CheckApi('dataRes-getAllRoomBedMapping', dataRes)
    return dataRes;
};

export const settingGetRoomBedMapping = async (data, token) => {
    CheckApi('getRoomBedMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getRoomBedMapping",
        data,
        token
    });
    CheckApi('dataRes-getRoomBedMapping', dataRes)
    return dataRes;
};

export const settingAddRoomBedMapping = async (data, token) => {
    CheckApi('addRoomBedMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addRoomBedMapping",
        data,
        token
    });
    CheckApi('dataRes-addRoomBedMapping', dataRes)
    return dataRes;
};

export const settingDeleteRoomBedMapping = async (item, token) => {
    CheckApi('deleteRoomBedMapping', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteRoomBedMapping",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteRoomBedMapping', dataRes)
    return dataRes;
};

export const settingUpdateRoomBedMapping = async (data, token) => {
    CheckApi('updateRoomBedMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateRoomBedMapping",
        data,
        token
    });
    CheckApi('dataRes-updateRoomBedMapping', dataRes)
    return dataRes;
};

export const settingGetRoomTreatmentMapping = async (data, token) => {
    CheckApi('getRoomTreatmentMapping', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getRoomTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-getRoomTreatmentMapping', dataRes)
    return dataRes;
};

export const settingAddRoomTreatmentMapping = async (data, token) => {
    CheckApi('addRoomTreatmentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addRoomTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-addRoomTreatmentMapping', dataRes)
    return dataRes;
};

export const settingDeleteRoomTreatmentMapping = async (item, token) => {
    CheckApi('deleteRoomTreatmentMapping', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteRoomTreatmentMapping",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteRoomTreatmentMapping', dataRes)
    return dataRes;
};

export const settingUpdateRoomTreatmentMapping = async (data, token) => {
    CheckApi('updateRoomTreatmentMapping', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateRoomTreatmentMapping",
        data,
        token
    });
    CheckApi('dataRes-updateRoomTreatmentMapping', dataRes)
    return dataRes;
};

// END BED  MANAGEMENT

// PROMOTION MANAGEMENT

export const settingGetPromotionCategory = async (data, token) => {
    CheckApi('getPromotionCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPromotionCategory",
        data,
        token
    });
    CheckApi('dataRes-getPromotionCategory', dataRes)
    return dataRes;
};

export const settingAddPromotionCategory = async (data, token) => {
    CheckApi('addPromotionCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPromotionCategory",
        data,
        token
    });
    CheckApi('dataRes-addPromotionCategory', dataRes)
    return dataRes;
};

export const settingDeletePromotionCategory = async (item, token) => {
    CheckApi('deletePromotionCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePromotionCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePromotionCategory', dataRes)
    return dataRes;
};

export const settingUpdatePromotionCategory = async (data, token) => {
    CheckApi('updatePromotionCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePromotionCategory",
        data,
        token
    });
    CheckApi('dataRes-updatePromotionCategory', dataRes)
    return dataRes;
};

export const settingGetPromotion = async (data, token) => {
    CheckApi('getPromotion', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPromotion",
        data,
        token
    });
    CheckApi('dataRes-getPromotion', dataRes)
    return dataRes;
};

export const settingAddPromotion = async (data, token) => {
    CheckApi('addPromotion', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPromotion",
        data,
        token
    });
    CheckApi('dataRes-addPromotion', dataRes)
    return dataRes;
};

export const settingDeletePromotion = async (item, token) => {
    CheckApi('deletePromotion', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePromotion",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePromotion', dataRes)
    return dataRes;
};

export const settingUpdatePromotion = async (data, token) => {
    CheckApi('updatePromotion', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePromotion",
        data,
        token
    });
    CheckApi('dataRes-updatePromotion', dataRes)
    return dataRes;
};

// END PROMOTION MANAGEMENT

// MEMBERSHIP MANAGEMENT

export const settingGetMembershipCategory = async (data, token) => {
    CheckApi('getMembershipCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembershipCategory",
        data,
        token
    });
    CheckApi('dataRes-getMembershipCategory', dataRes)
    return dataRes;
};

export const settingAddMembershipCategory = async (data, token) => {
    CheckApi('addMembershipCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembershipCategory",
        data,
        token
    });
    CheckApi('dataRes-addMembershipCategory', dataRes)
    return dataRes;
};

export const settingDeleteMembershipCategory = async (item, token) => {
    CheckApi('deleteMembershipCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteMembershipCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteMembershipCategory', dataRes)
    return dataRes;
};

export const settingUpdateMembershipCategory = async (data, token) => {
    CheckApi('updateMembershipCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateMembershipCategory",
        data,
        token
    });
    CheckApi('dataRes-updateMembershipCategory', dataRes)
    return dataRes;
};

export const settingGetMembershipAllSpaByidMembership = async (data, token) => {
    CheckApi('getMembershipAllSpaByidMembership', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembershipAllSpaByidMembership",
        data,
        token
    });
    CheckApi('dataRes-getMembershipAllSpaByidMembership', dataRes)
    return dataRes;
};

export const settingGetMembership = async (data, token) => {
    CheckApi('getMembership', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembership",
        data,
        token
    });
    CheckApi('dataRes-getMembership', dataRes)
    return dataRes;
};

export const settingAddMembership = async (data, token) => {
    CheckApi('addMembership', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembership",
        data,
        token
    });
    CheckApi('dataRes-addMembership', dataRes)
    return dataRes;
};

export const settingDeleteMembership = async (item, token) => {
    CheckApi('deleteMembership', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteMembership",
        data: item,
        token
    });
    CheckApi('dataRes-deleteMembership', dataRes)
    return dataRes;
};

export const settingUpdateMembership = async (data, token) => {
    CheckApi('updateMembership', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateMembership",
        data,
        token
    });
    CheckApi('dataRes-updateMembership', dataRes)
    return dataRes;
};

export const settingGetAllMembershipComplimentaryTreatment = async (data, token) => {
    CheckApi('getAllMembershipComplimentaryTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllMembershipComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-getAllMembershipComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingGetMembershipComplimentaryTreatment = async (data, token) => {
    CheckApi('getMembershipComplimentaryTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembershipComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-getMembershipComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingAddMembershipComplimentaryTreatment = async (data, token) => {
    CheckApi('addMembershipComplimentaryTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembershipComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-addMembershipComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingDeleteMembershipComplimentaryTreatment = async (item, token) => {
    CheckApi('deleteMembershipComplimentaryTreatment', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteMembershipComplimentaryTreatment",
        data: { item },
        token
    });
    CheckApi('dataRes-deleteMembershipComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingUpdateMembershipComplimentaryTreatment = async (data, token) => {
    CheckApi('updateMembershipComplimentaryTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateMembershipComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-updateMembershipComplimentaryTreatment', dataRes)
    return dataRes;
};


export const settingAddMembershipOtherSpa = async (data, token) => {
    CheckApi('addMembershipOtherSpa', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembershipOtherSpa",
        data,
        token
    });
    CheckApi('dataRes-addMembershipOtherSpa', dataRes)
    return dataRes;
};

export const settingDeleteMembershipOtherSpa = async (data, token) => {
    CheckApi('deleteMembershipOtherSpa', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteMembershipOtherSpa",
        data,
        token
    });
    CheckApi('dataRes-deleteMembershipOtherSpa', dataRes)
    return dataRes;
};

export const settingGetAllMembershipCustomer = async (data, token) => {
    CheckApi('getAllMembershipCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getAllMembershipCustomer",
        data,
        token
    });
    CheckApi('dataRes-getAllMembershipCustomer', dataRes)
    return dataRes;
};

export const settingGetCustomerSearchingMembership = async (data, token) => {
    CheckApi('getCustomerSearchingMembership', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerSearchingMembership",
        data,
        token
    });
    CheckApi('dataRes-getCustomerSearchingMembership', dataRes)
    return dataRes;
};

export const settingGetMembershipCustomer = async (data, token) => {
    CheckApi('getMembershipCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembershipCustomer",
        data,
        token
    });
    CheckApi('dataRes-getMembershipCustomer', dataRes)
    return dataRes;
};

export const settingAddMembershipCustomer = async (data, token) => {
    CheckApi('addMembershipCustomer', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembershipCustomer",
        data,
        token
    });
    CheckApi('dataRes-addMembershipCustomer', dataRes)
    return dataRes;
};

export const settingDeleteMembershipCustomer = async (item, token) => {
    CheckApi('deleteMembershipCustomer', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteMembershipCustomer",
        data: item,
        token
    });
    CheckApi('dataRes-deleteMembershipCustomer', dataRes)
    return dataRes;
};

export const settingUpdateMembershipIndexCustomer = async (data, token) => {
    CheckApi('updateMembershipIndexCustomer', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateMembershipIndexCustomer",
        data,
        token
    });
    CheckApi('dataRes-updateMembershipIndexCustomer', dataRes)
    return dataRes;
};

export const settingGetMembershipSubCustomerComplimentaryTreatment = async (data, token) => {
    CheckApi('getMembershipSubCustomerComplimentaryTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getMembershipSubCustomerComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-getMembershipSubCustomerComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingAddMembershipSubCustomerComplimentaryTreatment = async (data, token) => {
    CheckApi('addMembershipSubCustomerComplimentaryTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addMembershipSubCustomerComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-addMembershipSubCustomerComplimentaryTreatment', dataRes)
    return dataRes;
};

export const settingUpdateMembershipSubCustomerComplimentaryTreatment = async (data, token) => {
    CheckApi('updateMembershipSubCustomerComplimentaryTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateMembershipSubCustomerComplimentaryTreatment",
        data,
        token
    });
    CheckApi('dataRes-updateMembershipSubCustomerComplimentaryTreatment', dataRes)
    return dataRes;
};

// END MEMBERSHIP MANAGEMENT

// PACKAGE MANAGEMENT

export const settingGetPackageCategory = async (data, token) => {
    CheckApi('getPackageCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPackageCategory",
        data,
        token
    });
    CheckApi('dataRes-getPackageCategory', dataRes)
    return dataRes;
};

export const settingAddPackageCategory = async (data, token) => {
    CheckApi('addPackageCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPackageCategory",
        data,
        token
    });
    CheckApi('dataRes-addPackageCategory', dataRes)
    return dataRes;
};

export const settingDeletePackageCategory = async (item, token) => {
    CheckApi('deletePackageCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePackageCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePackageCategory', dataRes)
    return dataRes;
};

export const settingUpdatePackageCategory = async (data, token) => {
    CheckApi('updatePackageCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePackageCategory",
        data,
        token
    });
    CheckApi('dataRes-updatePackageCategory', dataRes)
    return dataRes;
};

export const settingGetPackage = async (data, token) => {
    CheckApi('getPackage', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPackage",
        data,
        token
    });
    CheckApi('dataRes-getPackage', dataRes)
    return dataRes;
};

export const settingAddPackage = async (data, token) => {
    CheckApi('addPackage', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPackage",
        data,
        token
    });
    CheckApi('dataRes-addPackage', dataRes)
    return dataRes;
};

export const settingDeletePackage = async (item, token) => {
    CheckApi('deletePackage', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePackage",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePackage', dataRes)
    return dataRes;
};

export const settingUpdatePackage = async (data, token) => {
    CheckApi('updatePackage', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePackage",
        data,
        token
    });
    CheckApi('dataRes-updatePackage', dataRes)
    return dataRes;
};

export const settingUpdateChangeStatusPackage = async (data, token) => {
    CheckApi('updateChangeStatusPackage', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateChangeStatusPackage",
        data,
        token
    });
    CheckApi('dataRes-updateChangeStatusPackage', dataRes)
    return dataRes;
};

export const settingGetPackageTreatment = async (data, token) => {
    CheckApi('getPackageTreatment', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPackageTreatment",
        data,
        token
    });
    CheckApi('dataRes-getPackageTreatment', dataRes)
    return dataRes;
};

export const settingAddPackageTreatment = async (data, token) => {
    CheckApi('addPackageTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addPackageTreatment",
        data,
        token
    });
    CheckApi('dataRes-addPackageTreatment', dataRes)
    return dataRes;
};

export const settingAddAllPackageTreatment = async (data, token) => {
    CheckApi('addAllPackageTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addAllPackageTreatment",
        data,
        token
    });
    CheckApi('dataRes-addAllPackageTreatment', dataRes)
    return dataRes;
};

export const settingDeletePackageTreatment = async (item, token) => {
    CheckApi('deletePackageTreatment', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deletePackageTreatment",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deletePackageTreatment', dataRes)
    return dataRes;
};

export const settingUpdatePackageTreatment = async (data, token) => {
    CheckApi('updatePackageTreatment', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updatePackageTreatment",
        data,
        token
    });
    CheckApi('dataRes-updatePackageTreatment', dataRes)
    return dataRes;
};

export const settingGetPackageProduct = async (data, token) => {
    CheckApi('getPackageProduct', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getPackageProduct",
        data,
        token
    });
    CheckApi('dataRes-getPackageProduct', dataRes)
    return dataRes;
};

// export const settingGetCheckDataDeletePackageProduct = async (data, token) => {
//     CheckApi('getCheckDataDeletePackageProduct', data, token)
//     // const dataRes = await 
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeletePackageProduct",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeletePackageProduct', dataRes)
//     return dataRes;
// };


// END PACKAGE MANAGEMENT

// Customer MANAGEMENT

export const settingGetOrganizationType = async (data, token) => {
    CheckApi('getOrganizationType', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getOrganizationType",
        data,
        token
    });
    CheckApi('dataRes-getOrganizationType', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteOrganizationType = async (data, token) => {
    CheckApi('getCheckDataDeleteOrganizationType', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteOrganizationType",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteOrganizationType', dataRes)
    return dataRes;
};

export const settingAddOrganizationType = async (data, token) => {
    CheckApi('addOrganizationType', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addOrganizationType",
        data,
        token
    });
    CheckApi('dataRes-addOrganizationType', dataRes)
    return dataRes;
};

export const settingDeleteOrganizationType = async (item, token) => {
    CheckApi('deleteOrganizationType', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteOrganizationType",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteOrganizationType', dataRes)
    return dataRes;
};

export const settingUpdateOrganizationType = async (data, token) => {
    CheckApi('updateOrganizationType', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateOrganizationType",
        data,
        token
    });
    CheckApi('dataRes-updateOrganizationType', dataRes)
    return dataRes;
};

export const settingGetOrganization = async (data, token) => {
    CheckApi('getOrganization', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getOrganization",
        data,
        token
    });
    CheckApi('dataRes-getOrganization', dataRes)
    return dataRes;
};

export const settingAddOrganization = async (data, token) => {
    CheckApi('addOrganization', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addOrganization",
        data,
        token
    });
    CheckApi('dataRes-addOrganization', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteOrganization = async (data, token) => {
    CheckApi('getCheckDataDeleteOrganization', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteOrganization",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteOrganization', dataRes)
    return dataRes;
};

export const settingDeleteOrganization = async (item, token) => {
    CheckApi('deleteOrganization', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteOrganization",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteOrganization', dataRes)
    return dataRes;
};

export const settingUpdateOrganization = async (data, token) => {
    CheckApi('updateOrganization', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateOrganization",
        data,
        token
    });
    CheckApi('dataRes-updateOrganization', dataRes)
    return dataRes;
};

export const settingGetOrganizationTreatmentPricing = async (data, token) => {
    CheckApi('getOrganizationTreatmentPricing', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getOrganizationTreatmentPricing",
        data,
        token
    });
    CheckApi('dataRes-getOrganizationTreatmentPricing', dataRes)
    return dataRes;
};

export const settingAddOrganizationTreatmentPricing = async (data, token) => {
    CheckApi('addOrganizationTreatmentPricing', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addOrganizationTreatmentPricing",
        data,
        token
    });
    CheckApi('dataRes-addOrganizationTreatmentPricing', dataRes)
    return dataRes;
};

export const settingDeleteOrganizationTreatmentPricing = async (item, token) => {
    CheckApi('deleteOrganizationTreatmentPricing', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteOrganizationTreatmentPricing",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteOrganizationTreatmentPricing', dataRes)
    return dataRes;
};

export const settingUpdateOrganizationTreatmentPricing = async (data, token) => {
    CheckApi('updateOrganizationTreatmentPricing', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateOrganizationTreatmentPricing",
        data,
        token
    });
    CheckApi('dataRes-updateOrganizationTreatmentPricing', dataRes)
    return dataRes;
};

export const settingGetOrganizationPackagePricing = async (data, token) => {
    CheckApi('getOrganizationPackagePricing', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getOrganizationPackagePricing",
        data,
        token
    });
    CheckApi('dataRes-getOrganizationPackagePricing', dataRes)
    return dataRes;
};

export const settingAddOrganizationPackagePricing = async (data, token) => {
    CheckApi('addOrganizationPackagePricing', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addOrganizationPackagePricing",
        data,
        token
    });
    CheckApi('dataRes-addOrganizationPackagePricing', dataRes)
    return dataRes;
};

export const settingDeleteOrganizationPackagePricing = async (item, token) => {
    CheckApi('deleteOrganizationPackagePricing', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteOrganizationPackagePricing",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteOrganizationPackagePricing', dataRes)
    return dataRes;
};

export const settingUpdateOrganizationPackagePricing = async (data, token) => {
    CheckApi('updateOrganizationPackagePricing', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateOrganizationPackagePricing",
        data,
        token
    });
    CheckApi('dataRes-updateOrganizationPackagePricing', dataRes)
    return dataRes;
};

export const settingDeleteOrganizationTreatmentPricingANDOrganizationPackagePricing = async (item, token) => {
    CheckApi('deleteOrganizationPackagePricing', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteOrganizationTreatmentPricingANDOrganizationPackagePricing",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteOrganizationTreatmentPricingANDOrganizationPackagePricing', dataRes)
    return dataRes;
}

export const settingGetCustomer = async (data, token) => {
    CheckApi('getCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomer",
        data,
        token
    });
    CheckApi('dataRes-getCustomer', dataRes)
    return dataRes;
};

export const settingGetCustomerByIdCustomer = async (data, token) => {
    CheckApi('getCustomerByIdCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerByIdCustomer",
        data,
        token
    });
    CheckApi('dataRes-getCustomerByIdCustomer', dataRes)
    return dataRes;
};


export const settingGetCustomerSearching = async (data, token) => {
    CheckApi('getCustomerSearching', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerSearching",
        data,
        token
    });
    CheckApi('dataRes-getCustomerSearching', dataRes)
    return dataRes;
};

export const settingAddCustomer = async (data, token) => {
    CheckApi('addCustomer', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addCustomer",
        data,
        token
    });
    CheckApi('dataRes-addCustomer', dataRes)
    return dataRes;
};

export const settingAddCustomerNotProvidePersonal = async (data, token) => {
    CheckApi('addCustomerNotProvidePersonal', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addCustomerNotProvidePersonal",
        data,
        token
    });
    CheckApi('dataRes-addCustomerNotProvidePersonal', dataRes)
    return dataRes;
};

export const settingDeleteCustomer = async (item, token) => {
    CheckApi('deleteCustomer', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteCustomer",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteCustomer', dataRes)
    return dataRes;
};

export const settingUpdateCustomer = async (data, token) => {
    CheckApi('updateCustomer', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateCustomer",
        data,
        token
    });
    CheckApi('dataRes-updateCustomer', dataRes)
    return dataRes;
};

export const settingUpdateRemarksCustomer = async (data, token) => {
    CheckApi('updateRemarksCustomer', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateRemarksCustomer",
        data,
        token
    });
    CheckApi('dataRes-updateRemarksCustomer', dataRes)
    return dataRes;
};

export const settingGetCheckCustomerDuplicated = async (data, token) => {
    CheckApi('getCheckCustomerDuplicated', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckCustomerDuplicated",
        data,
        token
    });
    CheckApi('dataRes-getCheckCustomerDuplicated', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteCustomer = async (data, token) => {
    CheckApi('getCheckDataDeleteCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteCustomer",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteCustomer', dataRes)
    return dataRes;
};

export const settingGetCustomerComplimentaryHistory = async (data, token) => {
    CheckApi('getCustomerComplimentaryHistory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerComplimentaryHistory",
        data,
        token
    });
    CheckApi('dataRes-getCustomerComplimentaryHistory', dataRes)
    return dataRes;
};

export const settingGetCustomerCouponCode = async (data, token) => {
    CheckApi('getCustomerCouponCode', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerCouponCode",
        data,
        token
    });
    CheckApi('dataRes-getCustomerCouponCode', dataRes)
    return dataRes;
};

export const settingGetCustomerCouponCodeByIdCustomer = async (data, token) => {
    CheckApi('getCustomerCouponCodeByIdCustomer', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerCouponCodeByIdCustomer",
        data,
        token
    });
    CheckApi('dataRes-getCustomerCouponCodeByIdCustomer', dataRes)
    return dataRes;
};

export const settingGetCustomerCouponCodeByCustomerCouponCode = async (data, token) => {
    CheckApi('getCustomerCouponCodeByCustomerCouponCode', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCustomerCouponCodeByCustomerCouponCode",
        data,
        token
    });
    CheckApi('dataRes-getCustomerCouponCodeByCustomerCouponCode', dataRes)
    return dataRes;
};

export const settingAddCustomerCouponCode = async (data, token) => {
    CheckApi('addCustomerCouponCode', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addCustomerCouponCode",
        data,
        token
    });
    CheckApi('dataRes-addCustomerCouponCode', dataRes)
    return dataRes;
};

// END Customer MANAGEMENT

// SERVICE FEE MANAGEMENT

export const settingGetServiceFee = async (data, token) => {
    CheckApi('getServiceFee', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getServiceFee",
        data,
        token
    });
    CheckApi('dataRes-getServiceFee', dataRes)
    return dataRes;
};

export const settingAddServiceFee = async (data, token) => {
    CheckApi('addServiceFee', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addServiceFee",
        data,
        token
    });
    CheckApi('dataRes-addServiceFee', dataRes)
    return dataRes;
};

export const settingDeleteServiceFee = async (item, token) => {
    CheckApi('deleteServiceFee', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteServiceFee",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteServiceFee', dataRes)
    return dataRes;
};

export const settingUpdateServiceFee = async (data, token) => {
    CheckApi('updateServiceFee', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateServiceFee",
        data,
        token
    });
    CheckApi('dataRes-updateServiceFee', dataRes)
    return dataRes;
};

// END SERVICE FEE MANAGEMENT

// Queue MANAGEMENT

export const settingGetQueueByDate = async (data, token) => {
    CheckApi('getQueueByDate', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getQueueByDate",
        data,
        token
    });
    CheckApi('dataRes-getQueueByDate', dataRes)
    return dataRes;
};

export const settingGetQueue = async (data, token) => {
    CheckApi('getQueue', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getQueue",
        data,
        token
    });
    CheckApi('dataRes-getQueue', dataRes)
    return dataRes;
};

export const settingAddQueue = async (data, token) => {
    CheckApi('addQueue', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addQueue",
        data,
        token
    });
    CheckApi('dataRes-addQueue', dataRes)
    return dataRes;
};

export const settingDeleteQueue = async (item, token) => {
    CheckApi('deleteQueue', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteQueue",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteQueue', dataRes)
    return dataRes;
};

export const settingUpdateQueue = async (data, token) => {
    CheckApi('updateQueue', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateQueue",
        data,
        token
    });
    CheckApi('dataRes-updateQueue', dataRes)
    return dataRes;
};

// END Queue MANAGEMENT

// INVENTORY MANAGEMENT

export const settingGetInventoryCategory = async (data, token) => {
    CheckApi('getInventoryCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getInventoryCategory",
        data,
        token
    });
    CheckApi('dataRes-getInventoryCategory', dataRes)
    return dataRes;
};

export const settingAddInventoryCategory = async (data, token) => {
    CheckApi('addInventoryCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addInventoryCategory",
        data,
        token
    });
    CheckApi('dataRes-addInventoryCategory', dataRes)
    return dataRes;
};

export const settingDeleteInventoryCategory = async (item, token) => {
    CheckApi('deleteInventoryCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteInventoryCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteInventoryCategory', dataRes)
    return dataRes;
};

export const settingUpdateInventoryCategory = async (data, token) => {
    CheckApi('updateInventoryCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateInventoryCategory",
        data,
        token
    });
    CheckApi('dataRes-updateInventoryCategory', dataRes)
    return dataRes;
};

export const settingGetInventory = async (data, token) => {
    CheckApi('getInventory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getInventory",
        data,
        token
    });
    CheckApi('dataRes-getInventory', dataRes)
    return dataRes;
};

export const settingAddInventory = async (data, token) => {
    CheckApi('addInventory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addInventory",
        data,
        token
    });
    CheckApi('dataRes-addInventory', dataRes)
    return dataRes;
};

export const settingDeleteInventory = async (item, token) => {
    CheckApi('deleteInventory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteInventory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteInventory', dataRes)
    return dataRes;
};

export const settingUpdateInventory = async (data, token) => {
    CheckApi('updateInventory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateInventory",
        data,
        token
    });
    CheckApi('dataRes-updateInventory', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteInventoryProduct = async (data, token) => {
    CheckApi('getCheckDataDeleteInventoryProduct', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteInventoryProduct",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteInventoryProduct', dataRes)
    return dataRes;
};

export const settingGetInventoryProductUnit = async (data, token) => {
    CheckApi('getInventoryProductUnit', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getInventoryProductUnit",
        data,
        token
    });
    CheckApi('dataRes-getInventoryProductUnit', dataRes)
    return dataRes;
};

export const settingAddInventoryProductUnit = async (data, token) => {
    CheckApi('addInventoryProductUnit', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addInventoryProductUnit",
        data,
        token
    });
    CheckApi('dataRes-addInventoryProductUnit', dataRes)
    return dataRes;
};

export const settingDeleteInventoryProductUnit = async (item, token) => {
    CheckApi('deleteInventoryProductUnit', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteInventoryProductUnit",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteInventoryProductUnit', dataRes)
    return dataRes;
};

export const settingGetCheckDataDeleteInventoryProductUnit = async (data, token) => {
    CheckApi('getCheckDataDeleteInventoryProductUnit', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCheckDataDeleteInventoryProductUnit",
        data,
        token
    });
    CheckApi('dataRes-getCheckDataDeleteInventoryProductUnit', dataRes)
    return dataRes;
};

export const settingDeleteInventoryTreatmentANDPackageProductQuantity = async (item, token) => {
    CheckApi('deleteInventoryTreatmentANDPackageProductQuantity', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteInventoryTreatmentANDPackageProductQuantity",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteInventoryTreatmentANDPackageProductQuantity', dataRes)
    return dataRes;
};

export const settingGetInventoryByInventoryCategory = async (data, token) => {
    CheckApi('getInventoryByInventoryCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getInventoryByInventoryCategory",
        data,
        token
    });
    CheckApi('dataRes-getInventoryByInventoryCategory', dataRes)
    return dataRes;
};

export const settingAddInventoryTreatmentANDPackageProductQuantity = async (data, token) => {
    CheckApi('addInventoryTreatmentANDPackageProductQuantity', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addInventoryTreatmentANDPackageProductQuantity",
        data,
        token
    });
    CheckApi('dataRes-addInventoryTreatmentANDPackageProductQuantity', dataRes)
    return dataRes;
};

// END INVENTORY MANAGEMENT

// COUPON MANAGEMENT

export const settingGetCouponCategory = async (data, token) => {
    CheckApi('getCouponCategory', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCouponCategory",
        data,
        token
    });
    CheckApi('dataRes-getCouponCategory', dataRes)
    return dataRes;
};

export const settingAddCouponCategory = async (data, token) => {
    CheckApi('addCouponCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addCouponCategory",
        data,
        token
    });
    CheckApi('dataRes-addCouponCategory', dataRes)
    return dataRes;
};

export const settingDeleteCouponCategory = async (item, token) => {
    CheckApi('deleteCouponCategory', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteCouponCategory",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteCouponCategory', dataRes)
    return dataRes;
};

export const settingUpdateCouponCategory = async (data, token) => {
    CheckApi('updateCouponCategory', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateCouponCategory",
        data,
        token
    });
    CheckApi('dataRes-updateCouponCategory', dataRes)
    return dataRes;
};

export const settingGetCoupon = async (data, token) => {
    CheckApi('getCoupon', data, token)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/getCoupon",
        data,
        token
    });
    CheckApi('dataRes-getCoupon', dataRes)
    return dataRes;
};

export const settingAddCoupon = async (data, token) => {
    CheckApi('addCoupon', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/addCoupon",
        data,
        token
    });
    CheckApi('dataRes-addCoupon', dataRes)
    return dataRes;
};

export const settingDeleteCoupon = async (item, token) => {
    CheckApi('deleteCoupon', item)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/deleteCoupon",
        data: {
            item
        },
        token
    });
    CheckApi('dataRes-deleteCoupon', dataRes)
    return dataRes;
};

export const settingUpdateCoupon = async (data, token) => {
    CheckApi('updateCoupon', data)
    // const dataRes = await 
    const dataRes = await Provider({
        type: "POST",
        url: "/setting/updateCoupon",
        data,
        token
    });
    CheckApi('dataRes-updateCoupon', dataRes)
    return dataRes;
};

// export const settingGetCheckDataDeleteCoupon = async (data, token) => {
//     CheckApi('getCheckDataDeleteCoupon', data, token)
//     // const dataRes = await
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeleteCoupon",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeleteCoupon', dataRes)
//     return dataRes;
// };

// export const settingGetCouponGet = async (data, token) => {
//     CheckApi('getCouponGet', data, token)
//     // const dataRes = await
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCouponGet",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCouponGet', dataRes)
//     return dataRes;
// };

// export const settingAddCouponGet = async (data, token) => {
//     CheckApi('addCouponGet', data)
//     // const dataRes = await
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/addCouponGet",
//         data,
//         token
//     });
//     CheckApi('dataRes-addCouponGet', dataRes)
//     return dataRes;
// };

// export const settingDeleteCouponGet = async (item, token) => {
//     CheckApi('deleteCouponGet', item)
//     // const dataRes = await
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/deleteCouponGet",
//         data: {
//             item
//         },
//         token
//     });
//     CheckApi('dataRes-deleteCouponGet', dataRes)
//     return dataRes;
// };

// export const settingGetCheckDataDeleteCouponGet = async (data, token) => {
//     CheckApi('getCheckDataDeleteCouponGet', data, token)
//     // const dataRes = await
//     const dataRes = await Provider({
//         type: "POST",
//         url: "/setting/getCheckDataDeleteCouponGet",
//         data,
//         token
//     });
//     CheckApi('dataRes-getCheckDataDeleteCouponGet', dataRes)
//     return dataRes;
// };

// END COUPON MANAGEMENT